import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "el-dialog__body-title" }

import { t } from '@/plugins/i18n'

import STable from '@/components/Table/index.vue'

import { ElMessage } from 'element-plus'

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  finalData: {
    type: Array,
    default: () => {
      return []
    }
  },
  currentUnit: {
    type: String,
    default: ''
  }
},
  emits: ['update:visible', 'refresh'],
  setup(__props, { emit: emits }) {

const props = __props



const columns = [
  {
    label: t('商品数量'),
    prop: 'num',
    align: 'center'
  },
  {
    label: t('最终采购价'),
    prop: 'price',
    align: 'center',
    slotName: 'price'
  }]


return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "custom-class": "problem-dialog",
    "destroy-on-close": "",
    "model-value": __props.visible,
    onClose: _cache[0] || (_cache[0] = ($event: any) => (emits('update:visible', false))),
    draggable: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('最终采购价详情')), 1),
      _createVNode(STable, {
        class: "productTable",
        ref: (_value, _refs) => {
          _refs['STableRef'] = _value
        },
        "table-data": __props.finalData,
        columns: columns,
        showPagination: false
      }, {
        price: _withCtx(({row}) => [
          _createElementVNode("div", null, _toDisplayString(row.price) + " " + _toDisplayString(__props.currentUnit), 1)
        ]),
        _: 1
      }, 8, ["table-data"])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})